import { Locales } from '@ratehub/base-ui';


function getMortgagesNewDocumentHref(locale) {
    const path = locale === Locales.FRENCH 
        ? '/hypotheque/appliquez'
        : '/mortgages/apply';
    // requirement: include current query parameters
    return `${path}${location.search}`;
}

export default getMortgagesNewDocumentHref;